// extracted by mini-css-extract-plugin
export var defaultWrapper = "_m0-3";
export var downloadButton = "_m0-4";
export var fileContainer = "_m0-9 _m0-7";
export var fileContainerBase = "_m0-7";
export var fileContainerFixedHeight = "_m0-8 _m0-7";
export var fileInfo = "_m0-5";
export var fileInfoWidthRestricted = "_m0-6";
export var fileType = "_m0-1";
export var fileTypeName = "_m0-2";
export var image = "_m0-0";
export var link = "_m0-b";
export var overflowEllipsis = "_m0-a";